import { IMultiSelectOption } from 'ngx-bootstrap-multiselect';
import { StatisticsFilters } from 'app/models/statistics.model';
import { ReportFilter } from 'app/services/helper.service';
import { StatisticsFilterLine, StatisticsTabKey } from './statistics-export.models';

export interface StatisticsFilterSummaryInput {
  tab: StatisticsTabKey;
  filters: StatisticsFilters;
  filterSelects: ReportFilter;
  allLabel: string;
}

function resolveNames(
  selectedIds: string[],
  options: IMultiSelectOption[] | undefined,
  allLabel: string
): string {
  if (!selectedIds?.length) {
    return allLabel;
  }
  if (!options?.length) {
    return selectedIds.join(', ');
  }
  const names = selectedIds
    .map((id) => options.find((opt) => String(opt.id) === String(id))?.name ?? id)
    .filter(Boolean);
  return names.length ? names.join(', ') : allLabel;
}

/**
 * Build human-readable filter lines for the statistics PDF title page.
 * Mirrors visibility rules from statistics.component.html.
 */
export function buildStatisticsFilterSummary(input: StatisticsFilterSummaryInput): StatisticsFilterLine[] {
  const { tab, filters, filterSelects, allLabel } = input;
  const lines: StatisticsFilterLine[] = [];

  if (tab !== 'alarmCenter' && filterSelects.location.texts?.defaultTitle) {
    lines.push({
      label: filterSelects.location.texts.defaultTitle,
      value: resolveNames(filters.locations, filterSelects.location.filterList, allLabel),
    });
  }

  if (tab !== 'activeUsers' && filterSelects.device.texts?.defaultTitle) {
    lines.push({
      label: filterSelects.device.texts.defaultTitle,
      value: resolveNames(filters.devices, filterSelects.device.filterList, allLabel),
    });
  }

  if (tab !== 'activeUsers' && filterSelects.deviceTypes.texts?.defaultTitle) {
    lines.push({
      label: filterSelects.deviceTypes.texts.defaultTitle,
      value: resolveNames(filters.deviceTypes, filterSelects.deviceTypes.filterList, allLabel),
    });
  }

  if (
    tab !== 'activeUsers' &&
    filters.deviceTypes.length > 0 &&
    filterSelects.activations.texts?.defaultTitle
  ) {
    lines.push({
      label: filterSelects.activations.texts.defaultTitle,
      value: resolveNames(
        filters.alertTypes,
        filterSelects.activations.filterList,
        allLabel
      ),
    });
  }

  if (tab !== 'activeUsers' && filterSelects.alertRoute.texts?.defaultTitle) {
    lines.push({
      label: filterSelects.alertRoute.texts.defaultTitle,
      value: resolveNames(filters.alertRoutes, filterSelects.alertRoute.filterList, allLabel),
    });
  }

  if (tab !== 'alarmCenter' && filterSelects.personnel.texts?.defaultTitle) {
    lines.push({
      label: filterSelects.personnel.texts.defaultTitle,
      value: resolveNames(filters.personnels, filterSelects.personnel.filterList, allLabel),
    });
  }

  return lines;
}
